<script setup lang="ts">
import { computed } from 'vue'
import type { UiColor } from '../../../types/api/reports'
import { severityToColor } from './gwTableUtils'
import { numKtoM } from '../../../helpers/formating'

type GwDecimalItemProps = {
  severities?: UiColor[]
  isTableValue?: boolean
  value: number
  decimals?: number
}

const props = withDefaults(defineProps<GwDecimalItemProps>(), {
  decimals: 2,
  isTableValue: false,
})
const color = computed(() => severityToColor(props.severities)(props.value))
</script>
<template>
  <div :style="isTableValue ? { color } : ''">
    {{ value && numKtoM(value, 1_000, decimals) }}
  </div>
</template>
